export const NO_STATUS = -1;
export const STATUS_NONE = 0;
export const STATUS_ACTIVE = 1;
export const STATUS_LATER = 2;
export const STATUS_MASTERED = 3;
export const STATUS_HIDDEN = 4;
export const STATUS_DELETED = 5;
export const FRONT_WORD = 0;
export const BACK_WORD = 1;
export const FRONT_NOTE = 2;
export const BACK_NOTE = 3;



// WEBPACK FOOTER //
// ./src/services/Card.js